import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { mode: { type: String, default: "date" } }

  connect() {
    if (typeof flatpickr === "undefined") return
    this.fp = flatpickr(this.element, {
      allowInput: true,
      dateFormat: this.modeValue === "datetime" ? "Y-m-d\\TH:i" : "Y-m-d",
      enableTime: this.modeValue === "datetime",
      time_24hr: true,
    })
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy()
      this.fp = null
    }
  }
}
